export default "__VITE_ASSET__Bn26H5o2__"